import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import printTicketCargo from '../../../../../utils/printers/CargoTicket';
import { flagPrintCargo } from '../../../../../actions';

const PrintCargoTicketButton = ({ ticket, dispatchFlagPrintCargo, print }) => {
  const printTicket = async () => {
    dispatchFlagPrintCargo(true);
    await printTicketCargo(typeof ticket === 'object' ? ticket : ticket.toJSON());
    setTimeout(()=>{
      dispatchFlagPrintCargo(false)
    }, 4000)
  };

  return (
    <Button color="light" className="border" onClick={printTicket} disabled={print}>
      <i className={`fa ${print ? "fa-spinner" : "fa-print"}`} /> Imprimir tickets
    </Button>
  );
};

PrintCargoTicketButton.propTypes = {
  ticket: PropTypes.oneOfType([PropTypes.instanceOf(Map), PropTypes.object])
    .isRequired,
  dispatchFlagPrintCargo: PropTypes.func.isRequired,
  print: PropTypes.bool.isRequired
};

const mapStateToProps = ({ CargoUnit }) => ({
  print: CargoUnit.Cargo.getIn(['current', 'print']),
});

const mapDispatchToProps = {
  dispatchFlagPrintCargo: flagPrintCargo,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintCargoTicketButton);
